import { useOrganization } from "../contexts/OrganizationContext";
import PlayerRegister from "./PlayerRegister";
import TournamentPlayerRegister from "./TournamentPlayerRegister";
import { Box, CircularProgress } from "@mui/material";

/**
 * Wrapper component that routes to the appropriate player registration
 * based on the organization's competition type
 */
export default function PlayerRegisterWrapper() {
  const { currentOrg, loading } = useOrganization();

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // Padel Eagle and tournament organizations use TournamentPlayerRegister
  const isTournamentOrg = currentOrg?.competitionType === "tournament";

  return isTournamentOrg ? <TournamentPlayerRegister /> : <PlayerRegister />;
}
